export default __webpack_public_path__ + "static/media/archive.86c11401.svg";